const breadCrumb = "Lotação de Servidores - Carga Horária";

const routes = [
  {
    path: "/validar-fechar-reabrir-carga-horaria",
    name: "validar-fechar-reabrir-carga-horaria",
    meta: {
      allowedPermissions: ["carga_horaria_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CargaHoraria/ValidarFecharReabrirCargaHoraria/ValidarFecharReabrirCargaHorariaHome.vue"
      ),
  },
];

export default routes;
